import "@pjs/theming/dist/theme.css";
import { injectCss } from "../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.rt-phi{text-indent:calc(var(--layout-list-indent)*-2);padding-left:calc(var(--layout-list-indent)*2)}.rt-pi{text-indent:calc(var(--layout-list-indent)*2)}`);